import type { Attribute, Html, HtmlBuilder } from "foldkit/html";

/**
 * In-flight state for a button that calls the API: disabled (no double
 * submit) and `aria-busy` while `busy`. `blocked` disables it without
 * marking it busy (e.g. an empty form).
 */
export const busyAttributes = <Message>(
	h: HtmlBuilder<Message>,
	busy: boolean,
	blocked = false,
): ReadonlyArray<Attribute<Message>> => [
	h.Disabled(busy || blocked),
	h.AriaBusy(busy),
];

/** The DaisyUI spinner shown inside a busy button, before its label. */
export const busySpinner = <Message>(
	h: HtmlBuilder<Message>,
	busy: boolean,
): Html =>
	busy
		? h.span(
				[h.Class("loading loading-spinner loading-xs"), h.AriaHidden(true)],
				[],
			)
		: h.empty;
